import { twMerge } from "tailwind-merge";

interface ISkeletonProps {
  variant?: "text" | "circular" | "rounded" | "rectangular";
  className?: string;
}
export const Skeleton: React.FC<React.PropsWithChildren<ISkeletonProps>> = ({
  variant = "text",
  className,
  children,
}) => {
  const animation =
    "origin-[0_55%] scale-[1,0.60] animate-pulse bg-[rgba(0,0,0,0.11)]";

  switch (variant) {
    case "rounded":
      return (
        <div
          className={twMerge(`h-10 w-full rounded-full`, animation, className)}
        >
          {children}
        </div>
      );
    case "circular":
      return (
        <div
          className={twMerge(
            `h-10 w-10 flex-shrink-0 rounded-full`,
            animation,
            className,
          )}
        >
          {children}
        </div>
      );
    case "rectangular":
      return (
        <div className={twMerge(`h-10 w-full`, animation, className)}>
          {children}
        </div>
      );
    default:
      return (
        <div
          className={twMerge(
            "h-auto w-full rounded before:select-none before:opacity-0 before:content-['S']",
            animation,
            className,
          )}
        >
          {children}
        </div>
      );
  }
};
